import { File } from '@kinetic-ui/data-layer';

export const isBase64 = (file: string | File) => (typeof file === 'string' ? true : false);
